document.addEventListener('DOMContentLoaded', function() {
  // Game container element
  const gameContainer = document.getElementById('hanoi-game');
  
  // Evitar inicializar o jogo em dispositivos móveis
  const isMobile = window.innerWidth < 768;
  if (!gameContainer || isMobile) return; // Exit if game container doesn't exist or on mobile

  // Game elements
  let scoreDisplay = document.getElementById('score-display'); // Changed from const to let
  let levelDisplay = document.getElementById('level-display'); // Changed from const to let
  const gameMessage = document.getElementById('game-message');
  const progressBar = document.getElementById('level-progress-bar');
  const progressContainer = document.querySelector('.level-progress');
  let movesDisplay = document.getElementById('moves-display'); // Changed from const to let
  
  // Tower of Hanoi game state
  let towers = [[], [], []];
  let selectedTower = null;
  let level = 1;
  let disks = 3; // Starting with 3 disks
  let moves = 0;
  let minMoves = 0;
  let gameActive = true;
  let score = 0;
  let draggedDisk = null;
  let touchStartX = 0;
  let touchStartY = 0;

  // Initialize the game
  initGame();

  // Initialize game
  function initGame() {
    // Reset game state
    gameActive = true;
    moves = 0;
    disks = 2 + level; // Level 1: 3 disks, Level 2: 4 disks, etc.
    minMoves = Math.pow(2, disks) - 1; // Minimum moves to solve
    towers = [[], [], []];
    selectedTower = null;
    updateMovesDisplay();
    
    // Hide restart button and message
    gameMessage.classList.add('d-none');
    
    // Set level display
    levelDisplay.textContent = level;
    
    // Show progress bar for levels > 1
    if (level > 1) {
      progressContainer.style.display = 'block';
    } else {
      progressContainer.style.display = 'none';
    }
    
    // Create towers and disks
    createGameElements();
    
    // Reset progress bar
    updateProgressBar();
  }

  // Update the moves counter in the UI
  function updateMovesDisplay() {
    if (movesDisplay) {
      movesDisplay.textContent = moves;
    }
  }

  // Add moves counter to game container
  function addMovesCounter() {
    const movesCounter = document.createElement('div');
    movesCounter.className = 'moves-container';
    
    // Buscar tradução do container do jogo (adicionado como data-attribute)
    const gameContainer = document.getElementById('hanoi-game');
    const errorGameContainer = gameContainer.closest('.error-game-container');
    const movesText = errorGameContainer?.dataset?.movesText || 'moves';
    
    movesCounter.innerHTML = `<i class="bi bi-arrow-left-right"></i> <span id="moves-display">0</span> ${movesText}`;
    gameContainer.appendChild(movesCounter);
    
    // Update reference to the moves display
    movesDisplay = document.getElementById('moves-display');
  }

  // Create the tower and disk elements
  function createGameElements() {
    // Clear the game container
    gameContainer.innerHTML = '';
    
    // Create the base
    const base = document.createElement('div');
    base.className = 'hanoi-base';
    gameContainer.appendChild(base);
    
    // Ensure score container exists
    const scoreContainer = document.createElement('div');
    scoreContainer.className = 'score-container';
    scoreContainer.innerHTML = `
      <span class="badge px-3 py-2" id="level-badge" style="background: linear-gradient(90deg, #0b92e6, #3cb95d); border-radius: 30px; box-shadow: 0 2px 6px rgba(11,146,230,0.15);">
        <i class="bi bi-layers me-1"></i> <span id="level-display">${level}</span>
      </span>
      <span class="badge ms-2 px-3 py-2" id="score-badge" style="background: linear-gradient(135deg, #0b92e6, #3cb95d); border-radius: 30px; box-shadow: 0 2px 6px rgba(11,146,230,0.15);">
        <i class="bi bi-star-fill me-1"></i> <span id="score-display">${score}</span>
      </span>
    `;
    gameContainer.appendChild(scoreContainer);
    
    // Create the towers
    for (let i = 0; i < 3; i++) {
      const tower = document.createElement('div');
      tower.className = 'hanoi-tower';
      tower.dataset.tower = i;
      
      // Create the tower rod
      const rod = document.createElement('div');
      rod.className = 'hanoi-rod';
      tower.appendChild(rod);
      
      // Add click event for tower selection
      tower.addEventListener('click', function() {
        selectTower(i);
      });
      
      // Add touch events for mobile
      tower.addEventListener('touchstart', handleTouchStart, { passive: false });
      tower.addEventListener('touchend', function(e) {
        handleTouchEnd(e, i);
      });
      
      gameContainer.appendChild(tower);
      
      // Initialize towers array
      towers[i] = [];
    }
    
    // Create disks on the first tower with improved colors
    for (let i = disks; i > 0; i--) {
      const disk = document.createElement('div');
      disk.className = 'hanoi-disk';
      disk.dataset.size = i;
      
      // Calculate width based on disk size but with a cap to prevent overflow
      // Valor base menor (de 40 para 30) e multiplicador menor (de 18 para 15)
      const width = Math.min(30 + (i * 15), 190); // Limite máximo de 190px
      disk.style.width = `${width}px`;
      
      // Use the site's color scheme for disks
      // Create a gradient from blue to green with varying hues
      const blueHue = 210; // Approximate hue for #0b92e6
      const greenHue = 140; // Approximate hue for #3cb95d
      
      // Calculate a color between blue and green based on disk size
      const diskRatio = i / disks;
      const hue = blueHue + (greenHue - blueHue) * diskRatio;
      const saturation = 75 + (diskRatio * 10);
      const lightness = 60 - (diskRatio * 10);
      
      // Use linear gradient for disks
      disk.style.background = `linear-gradient(to right, 
        hsl(${hue}, ${saturation}%, ${lightness}%), 
        hsl(${hue + 10}, ${saturation - 5}%, ${lightness + 5}%))`;
      
      // Add to the first tower's array
      towers[0].push(i);
      
      // Add drag-and-drop functionality
      disk.draggable = true;
      disk.addEventListener('dragstart', handleDragStart);
      disk.addEventListener('dragend', handleDragEnd);
      
      document.querySelector('.hanoi-tower[data-tower="0"]').prepend(disk);
    }
    
    // Add drop events to towers
    document.querySelectorAll('.hanoi-tower').forEach(tower => {
      tower.addEventListener('dragover', handleDragOver);
      tower.addEventListener('drop', handleDrop);
    });
    
    // Add moves counter with translated text
    addMovesCounter();
    
    // Update references to score and level displays
    scoreDisplay = document.getElementById('score-display');
    levelDisplay = document.getElementById('level-display');
    
    // Update disk positions
    updateDiskPositions();
  }
  
  // Handle drag start
  function handleDragStart(e) {
    if (!gameActive) return;
    
    const disk = e.target;
    const tower = disk.parentNode;
    const towerIndex = parseInt(tower.dataset.tower);
    
    // MODIFICAÇÃO: Apenas permitir arrastar o disco do topo (primeiro filho, não o último)
    if (disk !== tower.firstChild) {
      e.preventDefault();
      return;
    }
    
    draggedDisk = {
      element: disk,
      fromTower: towerIndex,
      size: parseInt(disk.dataset.size)
    };
    
    // Add a class for styling
    disk.classList.add('dragging');
    
    // For touch devices, keep track of the original position
    touchStartX = e.clientX || (e.touches && e.touches[0].clientX);
    touchStartY = e.clientY || (e.touches && e.touches[0].clientY);
  }

  // Handle drag over
  function handleDragOver(e) {
    e.preventDefault(); // Allow drop
  }

  // Handle drag end
  function handleDragEnd(e) {
    if (draggedDisk) {
      draggedDisk.element.classList.remove('dragging');
      draggedDisk = null;
    }
  }

  // Handle drop
  function handleDrop(e) {
    e.preventDefault();
    
    if (!draggedDisk) return;
    
    const targetTower = e.currentTarget;
    const toTowerIndex = parseInt(targetTower.dataset.tower);
    
    // Check if move is valid
    if (isValidMove(draggedDisk.fromTower, toTowerIndex)) {
      // Move the disk
      moveDisk(draggedDisk.fromTower, toTowerIndex);
    }
    
    // Reset drag state
    draggedDisk.element.classList.remove('dragging');
    draggedDisk = null;
  }

  // Handle touch start
  function handleTouchStart(e) {
    if (!gameActive) return;
    
    const tower = e.currentTarget;
    const towerIndex = parseInt(tower.dataset.tower);
    
    // Only proceed if there's a disk on this tower
    if (towers[towerIndex].length === 0) return;
    
    // MODIFICAÇÃO: Obter o disco do topo (primeiro filho, não o último)
    const disk = tower.firstChild;
    
    // Store information about the touched disk
    draggedDisk = {
      element: disk,
      fromTower: towerIndex,
      size: parseInt(disk.dataset.size)
    };
    
    // Add a class for styling
    disk.classList.add('dragging');
    
    // Store the starting touch position
    touchStartX = e.touches[0].clientX;
    touchStartY = e.touches[0].clientY;
    
    e.preventDefault(); // Prevent scrolling while dragging
  }

  // Handle touch end
  function handleTouchEnd(e, toTowerIndex) {
    if (!draggedDisk) return;
    
    // Check if move is valid
    if (isValidMove(draggedDisk.fromTower, toTowerIndex)) {
      // Move the disk
      moveDisk(draggedDisk.fromTower, toTowerIndex);
    }
    
    // Reset drag state
    draggedDisk.element.classList.remove('dragging');
    draggedDisk = null;
  }

  // Handle tower selection (for click-based gameplay)
  function selectTower(towerIndex) {
    if (!gameActive) return;
    
    // If no tower is selected yet
    if (selectedTower === null) {
      // Only select a tower with disks
      if (towers[towerIndex].length > 0) {
        selectedTower = towerIndex;
        document.querySelector(`.hanoi-tower[data-tower="${towerIndex}"]`).classList.add('selected');
      }
    } 
    // If a tower is already selected
    else {
      // If the same tower is clicked again, deselect it
      if (selectedTower === towerIndex) {
        document.querySelector(`.hanoi-tower[data-tower="${selectedTower}"]`).classList.remove('selected');
        selectedTower = null;
      } 
      // Try to move a disk from the selected tower to the new tower
      else if (isValidMove(selectedTower, towerIndex)) {
        moveDisk(selectedTower, towerIndex);
        document.querySelector(`.hanoi-tower[data-tower="${selectedTower}"]`).classList.remove('selected');
        selectedTower = null;
      }
      // Invalid move - change selection to the new tower if it has disks
      else if (towers[towerIndex].length > 0) {
        document.querySelector(`.hanoi-tower[data-tower="${selectedTower}"]`).classList.remove('selected');
        selectedTower = towerIndex;
        document.querySelector(`.hanoi-tower[data-tower="${towerIndex}"]`).classList.add('selected');
      }
    }
  }

  // Check if a move is valid
  function isValidMove(fromTower, toTower) {
    // Cannot move from an empty tower
    if (towers[fromTower].length === 0) return false;
    
    // Can always move to an empty tower
    if (towers[toTower].length === 0) return true;
    
    // Check if the top disk of the source tower is smaller than the top disk of the target tower
    return towers[fromTower][towers[fromTower].length - 1] < towers[toTower][towers[toTower].length - 1];
  }

  // Move a disk from one tower to another
  function moveDisk(fromTower, toTower) {
    // Get the disk size from the source tower
    const diskSize = towers[fromTower].pop();
    
    // Add it to the target tower
    towers[toTower].push(diskSize);
    
    // Update the visual representation
    updateDiskPositions();
    
    // Increment moves counter
    moves++;
    updateMovesDisplay();
    
    // Update progress
    updateProgressBar();
    
    // Check if the puzzle is solved
    checkWinCondition();
  }

  // Update the visual positions of all disks
  function updateDiskPositions() {
    // Remove all disks from towers visually
    document.querySelectorAll('.hanoi-disk').forEach(disk => disk.remove());
    
    // Add disks to their respective towers
    for (let i = 0; i < 3; i++) {
      const tower = document.querySelector(`.hanoi-tower[data-tower="${i}"]`);
      
      // Modificação: Inverter a ordem para que os discos maiores fiquem na base
      // Clone o array para não modificar o original
      const towerDisks = [...towers[i]];
      
      // Para cada disco na torre, em ordem do maior (base) para o menor (topo)
      for (let j = 0; j < towerDisks.length; j++) {
        const diskSize = towerDisks[j];
        
        const disk = document.createElement('div');
        disk.className = 'hanoi-disk';
        disk.dataset.size = diskSize;
        
        // Ajustado o cálculo da largura do disco com um limite máximo
        const width = Math.min(30 + (diskSize * 15), 190); // Limite máximo de 190px
        disk.style.width = `${width}px`;
        
        // Use the site's color scheme for disks
        const blueHue = 210; // Approximate hue for #0b92e6
        const greenHue = 140; // Approximate hue for #3cb95d
        
        // Calculate a color between blue and green based on disk size
        const diskRatio = diskSize / disks;
        const hue = blueHue + (greenHue - blueHue) * diskRatio;
        const saturation = 75 + (diskRatio * 10);
        const lightness = 60 - (diskRatio * 10);
        
        // Use linear gradient for disks
        disk.style.background = `linear-gradient(to right, 
          hsl(${hue}, ${saturation}%, ${lightness}%), 
          hsl(${hue + 10}, ${saturation - 5}%, ${lightness + 5}%))`;
        
        // Add drag-and-drop functionality
        disk.draggable = true;
        disk.addEventListener('dragstart', handleDragStart);
        disk.addEventListener('dragend', handleDragEnd);
        
        // MODIFICAÇÃO: Inserir discos no início da torre (prepend), em vez de no final (append)
        // para que os discos sejam empilhados de baixo para cima
        tower.prepend(disk);
      }
    }
  }

  // Update the progress bar
  function updateProgressBar() {
    if (level <= 1) return;
    
    // Base progress on number of disks moved to target tower
    const progress = Math.min(100, (towers[2].length / disks) * 100);
    progressBar.style.width = `${progress}%`;
  }

  // Check if the puzzle is solved
  function checkWinCondition() {
    // Puzzle is solved when all disks are on the third tower
    if (towers[2].length === disks) {
      gameActive = false;
      
      // Calculate score based on level and moves
      const efficiency = minMoves / moves; // 1.0 is perfect
      const levelBonus = level * 100;
      const moveBonus = Math.floor(efficiency * 200);
      const levelScore = levelBonus + moveBonus;
      
      score += levelScore;
      scoreDisplay.textContent = score;
      
      // Buscar traduções do container do jogo
      const errorGameContainer = gameContainer.closest('.error-game-container');
      const congratsTemplate = errorGameContainer?.dataset?.congratsTemplate || 
        'Congratulations! You solved level %{level} in %{moves} moves (minimum: %{min_moves})! +%{score} points';
      const minMovesText = errorGameContainer?.dataset?.minMovesText || 'minimum';
      
      // Show success message with proper translations
      const congratsMessage = congratsTemplate
        .replace('%{level}', level)
        .replace('%{moves}', moves)
        .replace('%{min_moves}', minMoves)
        .replace('%{score}', levelScore);
      
      gameMessage.textContent = congratsMessage;
      gameMessage.className = 'alert mt-3';
      gameMessage.classList.remove('d-none');
      
      // Get next level text from data attribute or use default
      const nextLevelTemplate = errorGameContainer?.dataset?.nextLevelTemplate || 'Level %{level}!';
      const nextLevelText = nextLevelTemplate.replace('%{level}', level + 1);
      
      // Show level up message in the game area
      const levelUpMsg = document.createElement('div');
      levelUpMsg.className = 'level-up-message';
      levelUpMsg.textContent = nextLevelText;
      gameContainer.appendChild(levelUpMsg);
      
      // Increase level and continue after delay
      level++;
      
      setTimeout(() => {
        levelUpMsg.remove();
        initGame();
      }, 4000);
    }
  }
});